import { render } from "./RecommendTitle.vue?vue&type=template&id=0653963e&scoped=true&ts=true"
import script from "./RecommendTitle.vue?vue&type=script&lang=ts"
export * from "./RecommendTitle.vue?vue&type=script&lang=ts"

import "./RecommendTitle.vue?vue&type=style&index=0&id=0653963e&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0653963e"]])

export default __exports__